module.exports = __webpack_public_path__ + "static/media/SolferiasLogo.23ff7c3f.jpg";